import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { FiArrowRight, FiCheckCircle, FiLock, FiMail } from 'react-icons/fi';
import { apiRequest } from '../services/api';

export default function PasswordAccess({ reset = false }) {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError(''); setMessage('');
    if (reset && password !== confirm) return setError('Las contraseñas no coinciden.');
    if (reset && !token) return setError('El enlace es inválido o está incompleto.');
    setLoading(true);
    try {
      const result = await apiRequest(reset ? '/api/auth/password/reset' : '/api/auth/password/forgot', {
        method: 'POST',
        auth: false,
        body: reset ? { token, password } : { email: email.trim().toLowerCase() },
      });
      setMessage(result.message);
    } catch (err) {
      setError(err.message || 'No pudimos completar la solicitud.');
    } finally {
      setLoading(false);
    }
  };

  return <Page><Card>
    <Mark>{reset ? <FiLock/> : <FiMail/>}</Mark>
    <Eyebrow>NIDO · ACCESO SEGURO</Eyebrow>
    <h1>{reset ? 'Creá una contraseña nueva.' : 'Recuperá tu acceso.'}</h1>
    <p>{reset
      ? 'Usá entre 10 y 128 caracteres, con mayúscula, minúscula y número.'
      : 'Ingresá tu correo. Si existe una cuenta compatible, te enviaremos un enlace de un solo uso.'}</p>
    <Form onSubmit={submit}>
      {!reset && <label>Email<input type="email" autoComplete="email" required value={email} onChange={e=>setEmail(e.target.value)} placeholder="nombre@email.com"/></label>}
      {reset && <>
        <label>Nueva contraseña<input type="password" autoComplete="new-password" minLength="10" maxLength="128" required value={password} onChange={e=>setPassword(e.target.value)}/></label>
        <label>Repetir contraseña<input type="password" autoComplete="new-password" minLength="10" maxLength="128" required value={confirm} onChange={e=>setConfirm(e.target.value)}/></label>
      </>}
      {error && <Notice $error role="alert">{error}</Notice>}
      {message && <Notice role="status"><FiCheckCircle/>{message}</Notice>}
      <Button disabled={loading || Boolean(message)}>{loading ? 'Procesando…' : reset ? 'Actualizar contraseña' : 'Enviar enlace'} <FiArrowRight/></Button>
    </Form>
    <Back to="/login">{reset && message ? 'Iniciar sesión' : 'Volver al acceso'} <FiArrowRight/></Back>
  </Card></Page>;
}

const Page=styled.main`min-height:calc(100dvh - 112px);padding:60px 22px;display:grid;place-items:center;background:radial-gradient(circle at 78% 12%,rgba(204,112,78,.15),transparent 38%),#f8f7f2;color:#243e45;`;
const Card=styled.section`width:min(520px,100%);padding:clamp(30px,6vw,52px);background:#fff;border:1px solid #dce3e1;border-radius:28px;box-shadow:0 30px 80px rgba(42,64,70,.11);h1{margin:12px 0 16px;font-size:clamp(2.25rem,7vw,3.45rem);line-height:.98;letter-spacing:-.055em}p{color:#6d7e80;line-height:1.6}`;
const Mark=styled.div`width:54px;height:54px;border-radius:50%;display:grid;place-items:center;background:#274d55;color:white;font-size:1.3rem`;
const Eyebrow=styled.div`margin-top:24px;color:#bd6546;font-size:.78rem;font-weight:850;letter-spacing:.16em`;
const Form=styled.form`display:grid;gap:16px;margin-top:28px;label{display:grid;gap:8px;font-size:.88rem;font-weight:800}input{height:56px;border:1px solid #d5ddda;border-radius:14px;padding:0 16px;font:inherit;font-weight:500;&:focus{outline:0;border-color:#bd6546;box-shadow:0 0 0 4px rgba(189,101,70,.11)}}`;
const Button=styled.button`height:58px;border:0;border-radius:14px;padding:0 19px;background:#c96f4c;color:white;display:flex;align-items:center;justify-content:space-between;font-size:1rem;font-weight:800;cursor:pointer;&:disabled{opacity:.55}`;
const Notice=styled.div`padding:13px;border-radius:12px;display:flex;gap:8px;align-items:center;background:${p=>p.$error?'#fff0eb':'#eaf6ef'};color:${p=>p.$error?'#a9462e':'#276044'};font-size:.9rem;line-height:1.4`;
const Back=styled(Link)`margin-top:24px;color:#31555c;text-decoration:none;font-weight:800;display:inline-flex;align-items:center;gap:7px`;
